import { IFormsInstanceRepository } from "domain/contracts/formsinstance.contract";
import { FormInstance, FormInstanceUpdate } from "domain/entities/form-instance";
import { Message } from "domain/entities/message";
import { FormInstanceInputFilter } from "domain/models/nimberforms-input-filters";
import { httpClient } from "infra/axios/axios-api";

class FormsInstanceRepository implements IFormsInstanceRepository{
    async create(instance: FormInstance): Promise<Message<FormInstance>> {
        const response = await httpClient.post("/formInstance", {data: instance});
        return response.data;
    }

    async getByFilter(filter: FormInstanceInputFilter): Promise<Message<FormInstance[]>> {
        const response = await httpClient.get("/formInstance", {params: filter});
        return response.data;
    }

    async update(instance: FormInstanceUpdate, id: string): Promise<Message<FormInstance>> {
        const response = await httpClient.put(`/formInstance/${id}`, {data: instance});
        return response.data;
    }

    async delete(id: string): Promise<Message<boolean>> {
        const response = await httpClient.delete(`/formInstance/${id}`);
        return response.data;
    }
}

export default new FormsInstanceRepository()